import emitterDataConfigApi from '@/api/config/emitterDataConfig'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function useEmitterById(interfaceId: any, emitterId: any) {
  return useQuery([[queryKeys.emitter], emitterId], async () => {
    if (!interfaceId || !emitterId) return null
    const { data } = await emitterDataConfigApi.getById(
      interfaceId.toString(),
      emitterId.toString(),
    )
    if (!data) return null

    return data
  })
}

export default useEmitterById
